import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import {
  Router,
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { isPlatformBrowser } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class ProfileDetailsResolverService implements Resolve<any> {
  isLoggedIn: boolean = false;
  isBrowser: boolean;

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private router: Router,
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let url = state.url;
    if (this.isBrowser) {
      // let prevUrl = document.referrer;
      // if (prevUrl == environment.LIVECHAT_HOST) {
      //   let token = this.cookieService.get("access_token");
      //   localStorage.setItem("access_token", token);
      //   this.auth.switchTo({to: 'emailValidation'}).subscribe((res: any)=> {
      //     localStorage.setItem("access_token", res.data.token);
      //     localStorage.setItem("ev_key", res.data['ev-key']);
      //     this.cookieService.set("access_token", res.data.token);
      //   })
      // }
      if (localStorage.getItem("access_token")) {
        return this.auth.getUserProfile().pipe(
          catchError((err) => {
            if (err.status === 401) {
              localStorage.removeItem("access_token");
              location.reload();
              return throwError(err);
            }
          })
        );
      }
      else if (url.includes("/dashboard")) {
        this.router.navigate(['/login'], { queryParams: { 'redirectURL': url } });
      }
    }
  }
}
